import { FC } from 'react';
import { styled } from 'styled-components';
import SettingsIcon from '@/assets/images/settings.svg?react';
import { palette } from '@/constants/styles';
import Navigation from '@/components/navigation';
import UserPanel from '@/components/user-panel';
import { PartnerPicker } from './PartnerPicker';

const TopBar: FC = () => {
	return (
		<Container>
			<Header>
				<PartnerPicker />
				<FlexContainer>
					<Settings />
					<UserPanel />
				</FlexContainer>
			</Header>

			<Navigation />
		</Container>
	);
};

const Container = styled.div`
	position: sticky;
	top: 0;
	z-index: 1000;
`;

const Header = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	height: 50px;
	background-color: ${palette.primaryGray};
	top: 0;
	padding: 0 40px;
`;

const FlexContainer = styled.div`
	display: flex;
	align-items: center;
`;

const Settings = styled(SettingsIcon)`
	cursor: pointer;
`;

export default TopBar;
